import React from 'react';
import type { AllergyResponse } from '../../../../../../Types/schema-helpers';
import { getCategoryIconComponent } from '../../../../../../ConfigFiles/colors/allergies_colors';
import { TriforceIndicator } from './TriforceIndicator';

interface AllergyPillProps {
  allergy: AllergyResponse;
  isSelected: boolean;
  onClick: () => void;
}

export const AllergyPill: React.FC<AllergyPillProps> = ({ allergy, isSelected, onClick }) => {
  // Retrieve the React Icon component
  const CategoryIcon = getCategoryIconComponent(allergy.category);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`btn border rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2 transition-all ${
        isSelected ? 'btn-primary text-white shadow-sm' : 'btn-light hover-shadow text-dark'
      }`}
      style={{ cursor: 'pointer' }}
    >
      {/* 1. Allergen Name */}
      <span className="fw-semibold">{allergy.allergen}</span>

      {/* 2. Triforce Indicator */}
      <TriforceIndicator
        status={allergy.status}
        criticality={allergy.criticality}
        severity={allergy.severity}
        size={6}
      />

      {/* 3. React Icon Component on the Right */}
      <span className="d-inline-flex align-items-center justify-content-center">
        <CategoryIcon
          size={18}
          className={isSelected ? 'text-white' : 'text-primary'}
        />
      </span>
    </button>
  );
};